<template>
    <v-layout
      text-xs-center
      wrap
      pt-3
    >
      <v-flex xs12>
          <h1>Team Manager Change</h1>
          <h1>팀 멤버에게 대표자 권한 넘기기</h1>
      </v-flex>

      <v-layout row v-if="mode_complete">
        <v-flex xs12>
            Processing Complete / 완료
	    <br/>
	    <v-btn color='error' :to="`/events/${this.$route.params.event_id}`" >OK</v-btn>
        </v-flex>
      </v-layout>

      <v-layout row v-if="mode_confirm">
        <v-flex xs12>
            <b>Is this the right person?</b>

            <br/>
            {{ attendee.full_name }} / {{ attendee.native_name }} / {{ attendee.nickname }}
            <br/>
            에게 팀 대표자 권한을 넘깁니다. 
            <br/>  
                                                                                                               
            <v-alert                                           
              :value="true"                                                              
              type="info"                                                                                                                  
            >      
                이후 멤버 입력 등 팀 관리 기능을 사용할 수 없습니다. 동의하십니까? 
            </v-alert>                                                              
                                                
                   
            <v-btn xs4 color='success' @click="confirm">Transfer/넘기기</v-btn>                            
            <v-btn xs4 color='error' @click="cancel_confirm">Cancel/취소</v-btn>

            {{ error_message }}
        </v-flex>
      </v-layout>

      <v-layout row v-if="mode_select">
            <v-flex xs3>
              <b>English</b>
            </v-flex>
            <v-flex xs3>
              <b>Native</b>
            </v-flex>
            <v-flex xs3>
              <b>Nickname</b>
            </v-flex>
            <v-flex xs3>
              <b>Pick</b>
            </v-flex>
      </v-layout>
      <v-flex xs12 v-for="attendee in team_attendees" :key="attendee.id" v-if="mode_select" class='choices'>
        <v-layout row align-center>
            <v-flex xs3 fill-height>
              {{ attendee.full_name }}
            </v-flex>
            <v-flex xs3 fill-height>
              {{ attendee.native_name }}
            </v-flex>
            <v-flex xs3 fill-height>
              {{ attendee.nickname }}
            </v-flex>
            <v-flex xs3 fill-height>
              <v-btn @click="pick(attendee)" :disabled="!not_me(attendee)">Pick/선택</v-btn>
            </v-flex>
        </v-layout>
      </v-flex >
      <v-flex text-xs-center align-center v-if="mode_select">
        <v-btn color='error' :to="`/events/${this.$route.params.event_id}/my_team`" >Cancel</v-btn>
      </v-flex>
      <br/>
      <br/>
      <hr/>
      {{ user_agent }}
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import {fetcher} from '@/fetcher';

// Mode 1: Select existing attendee to transfer management only
// Mode 2: Enter transfer code to transfer management & event ticket together

export default {
  props: [],
  data: () => ({
    mode: 'select',
    attendee: {},
    error_message: '',
  }),
  methods: {
    not_me(att) {
      let same = this.myprofile?.attendees?.find(ma => ma.id == att.id);
      if (!!!same) return true;
      return false;
    },
    pick(att) {
      this.$data.attendee = att;
      this.$data.mode = 'confirm';
    },
    cancel_confirm() {
      this.$data.attendee = {};
      this.$data.mode = 'select';
    },
    confirm() {
      fetcher
        .put('/myprofile/team_manager_swap', {
          event_id: this.$route.params.event_id,
          team_id: this.$route.params.team_id,
          attendee_id: this.$data.attendee.id,
        })
        .then(res => {
          if (res.data.success) {
            this.$data.error_messages = [];
            this.$data.mode = 'complete';
            this.$data.attendee = {};
          } else {
            this.$data.error_messages = this.data.message;
          }
        });
    },
  },
  beforeMount: async function() {
    let t1 = this.$store.dispatch('loadEvents');
    let t2 = this.$store.dispatch('loadAttendees');
    let t3 = this.$store.dispatch('loadEventTeams', {
      event_id: this.$route.params.event_id,
    });

    await t1;
    await t2;
    await t3;
  },
  computed: {
    ...mapState(['events', 'event_teams', 'myprofile']),
    mode_select() {
      return this.$data.mode == 'select';
    },
    mode_confirm() {
      return this.$data.mode == 'confirm';
    },
    mode_complete() {
      return this.$data.mode == 'complete';
    },
    team() {
      if (!!!this.event_teams) {
        return undefined;
      }
      return this.event_teams?.find(x => {
        return x.id == this.$route.params.team_id;
      });
    },
    event() {
      if (!!!this.events) {
        return undefined;
      }
      return this.events?.find(x => {
        return x.id == this.$route.params.event_id;
      });
    },
    team_attendees() {
      if (!!!this.event_teams) {
        return undefined;
      }
      let tteam = this.event_teams?.find(x => {
        return x.id == this.$route.params.team_id;
      });
      if (!!tteam) {
        return tteam.room_allocations.map(ra => ra.attendees).flat();
      } else {
        return [];
      }
    },
    user_agent() {
      return navigator.userAgent;
    },
  },
  watch: {},
};
</script>

<style>
.choices:nth-child(even) {
  background: #ddd;
}
.choices:nth-child(odd) {
  background: #fff;
}
</style>
